(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bluorngxcollaborations"] && !Shopify.designMode) return;
  try {
    
    const lenis = new Lenis({
        smoothWheel: true,
        smoothTouch: false,
        normalizeWheel: true,
        ignore: el => el.classList.contains("scroll-section")
    });
 
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add(time => {
        lenis.raf(time * 700);
    });
 
    const container = document.getElementById('stackSlider');
    const buttons = document.querySelectorAll(".collab-block-data-right");
 
    buttons.forEach((button) => {
        button.addEventListener("touchstart", (e) => {
            e.stopPropagation();
        });
    });
 
    if (!container) return;
 
    const slides = Array.from(container.children);
    const totalSlides = slides.length;
    let currentIndex = 0;
 
    function isMobileMode() {
        return window.innerWidth <= 950;
    }
 
    function applyStackMode(enable) {
        if (enable) {
            slides.forEach(slide => {
                slide.style.position = 'absolute';
                slide.style.width = '75%';
                slide.style.minWidth = '75%';
                slide.style.height = '40%';
                slide.style.left = '50%';
                slide.style.top = '46%';
                slide.style.transform = 'translate(-50%, -50%)';
                slide.style.transformOrigin = 'center center';
                slide.style.transition = 'transform 0.8s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.6s ease, filter 0.8s ease';
            });
        } else {
            slides.forEach(slide => {
                slide.style.position = '';
                slide.style.width = '';
                slide.style.minWidth = '';
                slide.style.left = '';
                slide.style.top = '';
                slide.style.transform = '';
                slide.style.transformOrigin = '';
                slide.style.transition = '';
                slide.style.opacity = '';
                slide.style.pointerEvents = '';
                slide.style.zIndex = '';
                slide.style.filter = '';
            });
 
            container.style.position = '';
            container.style.height = '';
            container.style.overflow = '';
        }
    }
 
    function getStackSettings() {
        const width = window.innerWidth;
        if (width <= 480) {
            return { scaleStep: 0.17, translateStep: 24, maxBlur: 16, rotateStep: 14 };
        } else {
            return { scaleStep: 0.14, translateStep: 30, maxBlur: 24, rotateStep: 11 };
        }
    }
 
    function updateSlides() {
    if (!isMobileMode()) return;

    const { scaleStep, translateStep, maxBlur, rotateStep } = getStackSettings();

    slides.forEach((slide, i) => {
        let offset = i - currentIndex;
        
        // Circular logic for infinite loop
        if (Math.abs(offset) > totalSlides / 2) {
            offset += offset > 0 ? -totalSlides : totalSlides;
        }

        const absOffset = Math.abs(offset);
        const direction = offset > 0 ? 1 : -1;

        // --- VISIBILITY LOGIC: Main + 2 above + 2 below ---
        if (absOffset === 0) {
            slide.style.opacity = '1';
            slide.style.pointerEvents = 'auto'; // Only active card is clickable
        } else if (absOffset <= 2) {
            // This shows the 2 cards before and 2 cards after
            slide.style.opacity = '1'; 
            slide.style.pointerEvents = 'none';
        } else {
            // Hide everything else
            slide.style.opacity = '0';
            slide.style.pointerEvents = 'none';
        }
        // ------------------------------------------------

        // Z-Index: Lower for cards further away
        slide.style.zIndex = totalSlides - absOffset;

        // Visual Transformations
        const scale = 1 - absOffset * scaleStep;
        const translateY = direction * absOffset * translateStep;
        const rotateX = -direction * absOffset * rotateStep;

        slide.style.transform = `
            translate(-50%, -50%)
            translateY(${translateY}%)
            scale(${scale})
            rotateX(${rotateX}deg)
        `;

        // Effects: Blur and Brightness
        const blurAmount = absOffset * (maxBlur / 4);
        const brightness = Math.max(0.5, 1 - absOffset * 0.2);
        slide.style.filter = `blur(${blurAmount}px) brightness(${brightness})`;
    });

    // Ensure the top-most card is perfectly centered and crisp
    if (slides[currentIndex]) {
        slides[currentIndex].style.zIndex = totalSlides;
        slides[currentIndex].style.transform = 'translate(-50%, -50%) scale(1) rotateX(0deg)';
        slides[currentIndex].style.filter = 'blur(0px) brightness(1)';
        slides[currentIndex].style.opacity = '1';
    }
}
 
    function nextSlide() {
        if (!isMobileMode()) return;
        currentIndex = (currentIndex + 1) % totalSlides;
        updateSlides();
    }
 
    function prevSlide() {
        if (!isMobileMode()) return;
        currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        updateSlides();
    }
 
    // ── Swipe logic ────────────────────────────────────────
    let isDragging = false;
    let startY = 0;
    const threshold = () => window.innerWidth <= 480 ? 50 : 80;
 
    const startDrag = (e) => {
        if (!isMobileMode()) return;
 
        const touchedElement = e.target.closest('.slide') || e.target;
        if (!slides[currentIndex].contains(touchedElement) && touchedElement !== slides[currentIndex]) {
            return;
        }
 
        e.preventDefault();
        isDragging = true;
        startY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
    };
 
    const moveDrag = (e) => {
        if (!isDragging || !isMobileMode()) return;
        e.preventDefault();
 
        const currentY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
        const diff = startY - currentY;
 
        if (Math.abs(diff) > threshold()) {
            if (diff > 0) nextSlide();
            else prevSlide();
            isDragging = false;
        }
    };
 
    const endDrag = () => {
        isDragging = false;
    };
 
    container.addEventListener('touchstart', startDrag, { passive: false });
    container.addEventListener('mousedown', startDrag, { passive: true });
    container.addEventListener('touchmove', moveDrag, { passive: false });
    container.addEventListener('mousemove', moveDrag);
    container.addEventListener('touchend', endDrag);
    container.addEventListener('touchcancel', endDrag);
    container.addEventListener('mouseup', endDrag);
    container.addEventListener('mouseleave', endDrag);
 
    // Keyboard navigation
    document.addEventListener('keydown', e => {
        if (!isMobileMode()) return;
        if (['ArrowUp', 'w', 'W'].includes(e.key)) prevSlide();
        if (['ArrowDown', 's', 'S'].includes(e.key)) nextSlide();
    });
 
    function initialize() {
        if (isMobileMode()) {
            container.classList.add("visible");
            applyStackMode(true);
            currentIndex = 0;
            updateSlides();
        } else {
            applyStackMode(false);
        }
    }
 
    // Initial load
    window.addEventListener('load', initialize);
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
